export default "__VITE_ASSET__CEanpgoy__"